import { render, staticRenderFns } from "./OperaGoodsInfoWindow.vue?vue&type=template&id=f346d276&scoped=true&"
import script from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsInfoWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsInfoWindow.vue?vue&type=style&index=0&id=f346d276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f346d276",
  null
  
)

export default component.exports